import { Action } from '@ngrx/store';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

export interface IToastie {
  message: string;
  toastType: ToastType;
  showNotification: boolean;
}

/**
 * Type guard to check if an action should show a toast notification
 * Checks that the action has toast properties AND showNotification is true
 */
export function isToastieAction(action: Action): action is Action & { toast: IToastie } {
  if (!action || typeof action !== 'object' || !('toast' in action)) {
    return false;
  }

  const toast = (action as Record<string, unknown>).toast;
  return (
    toast !== null &&
    typeof toast === 'object' &&
    'message' in toast &&
    'toastType' in toast &&
    'showNotification' in toast &&
    typeof toast.message === 'string' &&
    ['success', 'error', 'info', 'warning'].includes(toast.toastType as ToastType) &&
    typeof toast.showNotification === 'boolean' &&
    toast.showNotification
  );
}
